<div
  class="w-full h-full flex flex-col gap-8 p-4 max-md:gap-2 max-md:p-3 bg-white rounded border border-solid border-cp-primary-20"
>
  <div class="flex justify-between max-md:items-center max-md:gap-2">
    <div>
      @if (logo()) {
        <img
          [src]="'data:image/svg+xml;base64,' + logo()"
          [alt]="ergebnis().versichererName + ' logo'"
          class="max-h-16 max-w-32 min-w-32 max-md:max-h-8 max-md:max-w-24 max-md:min-w-24 max-md:object-contain max-md:object-left w-auto h-auto"
          width="128"
        />
      }
    </div>
    <div>
      <button
        mat-flat-button
        class="btn-primary-sm !bg-cp-secondary-100 !text-white !rounded-full"
        (click)="openAntrag.emit(ergebnis())"
      >
        Antrag
      </button>
    </div>
  </div>
  @if (isBest()) {
    <span
      class="best-badge inline-flex items-center justify-center bg-[#4E997E] text-white text-xs font-semibold leading-[14px] h-6 px-4 rounded-full"
    >
      Preis-/Leistungssieger
    </span>
  }
  @if (ergebnis().rating.wert > 0) {
    <ui-rating-tooltip [ratingWert]="ergebnis().rating.wert">
      <ui-star-rating [value]="ergebnis().rating.wert" />
    </ui-rating-tooltip>
  }

  <div class="flex justify-between max-md:gap-2">
    <div class="text-base max-md:text-sm">{{ ergebnis().name }}</div>
    <strong class="max-md:text-sm">{{ ergebnis().bruttoBetrag | currency }}</strong>
  </div>
</div>
